import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { fetchSamples } from "../sample_reporting/Utils/SamplesFetch";
import ContractReviewSearchForm from "./ContractReviewSearchForm";

function ContractReviewSearch({ onSearch, laboratory_company_id }, ref) {
  // save parameters of the last search so we can re-run it when reloading data
  const [lastSearchParams, setLastSearchParams] = useState({});

  const findSamples = ({
    testingCategory,
    company_id,
    company_branch_id,
    dateFilter,
    start_date,
    end_date,
    require_contract_review,
    received,
    received_by_company_branch_id,
    without_prepayment_authorisation,
  }) => {
    const searchParams = {
      company_id,
      start_date,
      end_date,
      company_branch_id,
      testing_category_id: testingCategory,
      date_filter: dateFilter,
      include_contracted_techniques: true,
      require_contract_review,
      received,
      laboratory_company_id,
      received_by_company_branch_id,
      without_prepayment_authorisation,
    };
    setLastSearchParams(searchParams);
    fetchSamples(searchParams).then(onSearch);
  };

  useImperativeHandle(ref, () => ({
    search: () => fetchSamples(lastSearchParams).then(onSearch),
  }));

  return (
    <ContractReviewSearchForm
      onSubmit={findSamples}
      laboratory_company_id={laboratory_company_id}
    />
  );
}

ContractReviewSearch = forwardRef(ContractReviewSearch);

export default ContractReviewSearch;
